import AboutTemplate from "../../components/about/AboutTemplate";
import Page from "../Page";
import { Link, Typography } from "@mui/material";
import { Link as RouterLink } from "react-router-dom";
import Section from "../../components/about/Section";
import ResponsiveImage from "../../components/about/ResponsiveImage";

const PlannerTemplates = () => {
  return (
    <Page
      className="about-page planner-templates-page"
      pageKey="planner-templates"
    >
      <AboutTemplate>
        <Typography variant="h1">Templates</Typography>

        <Section>
          <Typography variant="p1">
            Templates allow you to save a day plan layout and reuse it on
            different days. If you have a routine that repeats - like a standard
            work day or a weekend schedule - templates make it easy to set up
            your day in seconds.
          </Typography>
        </Section>

        <Section title="Saving a template">
          <Typography variant="p1">
            Once you've set up your day with the blocks you want, open the Day
            Configuration panel and click <strong>"Save as Template"</strong>.
          </Typography>
          <Typography variant="p1">
            Give your template a name, choose an emoji and colour to help you
            identify it, and optionally add a short description.
          </Typography>
          <ResponsiveImage
            pageKey="plannerTemplates"
            imageName="save-template-dialog"
            size="medium"
          />
        </Section>

        <Section title="Loading a template">
          <Typography variant="p1">
            When you open the{" "}
            <Link
              component={RouterLink}
              to="/about/features/day-planner"
              variant="p1Link"
            >
              Day Planner
            </Link>{" "}
            on a day that doesn't have a plan yet, you'll see the template
            selector. Choose a template to pre-fill your day with the saved
            blocks.
          </Typography>
          <Typography variant="p1">
            You can also access the template selector from the Day Configuration
            panel at any time.
          </Typography>
          <ResponsiveImage
            pageKey="plannerTemplates"
            imageName="load-template"
            size="medium"
          />
        </Section>

        <Section title="Editing and deleting templates">
          <Typography variant="p1">
            You can edit a template's name, emoji, colour, and description by
            clicking the edit icon next to it in the template selector.
          </Typography>
          <Typography variant="p1">
            To delete a template, click the delete icon. This will not affect
            any days that have already been planned using the template - it only
            removes the template from the list.
          </Typography>
          <ResponsiveImage
            pageKey="plannerTemplates"
            imageName="template-edit-delete"
            size="medium"
          />
        </Section>

        <Section title="How templates work with blocks">
          <Typography variant="p1">
            When a template is loaded, it recreates the block structure from
            when the template was saved. Time blocks and activity blocks are
            restored as they were. Task blocks keep their time boundaries but
            will need new tasks assigned, since the specific tasks you want to
            work on will likely change from day to day.
          </Typography>
        </Section>
      </AboutTemplate>
    </Page>
  );
};

export default PlannerTemplates;
